export const SET_PAYMENT_METHOD = "SET_PAYMENT_METHOD";
export const SET_PAYMENT_METHODS = "SET_PAYMENT_METHODS";
export const ADD_PAYMENT_METHOD = "ADD_PAYMENT_METHOD";
export const UPDATE_PAYMENT_METHOD = "UPDATE_PAYMENT_METHOD";
export const DELETE_PAYMENT_METHOD = "DELETE_PAYMENT_METHOD";
